/**
 * Created by Ning Jiang on 11/22/2016.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {OutsourcedGameAssets} from "./OutsourcedGameAssets";
import {OutsourcedSound} from "./sound/OutsourcedSound";
import {OutsourcedBackgroundElements} from "./view/OutsourcedBackgroundElements";
import {OutsourcedWinPresentation} from "./gameflow/OutsourcedWinPresentation";
import {OutsourcedBetPresentation} from "./gameflow/OutsourcedBetPresentation";
import {OutsourcedNormalResultPresentation} from "./gameflow/OutsourcedNormalResultPresentation";
import {OursourcedIdleNormalPresentation} from "./gameflow/OursourcedIdleNormalPresentation";
import {OutsourcedModel} from "./server/OutsourcedModel";
import {OutsourcedWinView} from "./view/OutsourcedWinView";
import {OutsourcedTransitionScreenView} from "./view/OutsourcedTransitionScreenView";
import {TemplateAsset, TemplateLoader} from "@nolimitcity/slot-launcher/bin/loader/TemplateLoader";
import {OutsourcedStatics} from "./config/OutsourcedStatics";
import {RestoreUtils} from "./utils/RestoreUtils";
import {OutsourcedReelView} from "./reels/OutsourcedReelView";
import {OutsourcedSymbolFactory} from "./reels/symbols/SymbolFactory";
import {OutsourcedFreespinsIdlePresentation} from "./gameflow/OutsourcedFreespinsIdlePresentation";
import {OutsourcedForegroundElements} from "./view/OutsourcedForegroundElements";
import {OutsourcedFreespinsWinPresentation} from "./gameflow/OutsourcedFreespinsWinPresentation";
import {OutsourcedFreespinsResultPresentation} from "./gameflow/OutsourcedFreespinsResultPresentation";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {
    BonusFeatureDisplayConfigurationList
} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
import {Label} from "@nolimitcity/slot-launcher/bin/gui/labels/Label";
import {BonusBuyPopUpContent} from "@nolimitcity/promo-panel/bin/feature/generic/BonusBuyPopUpContent";
import {OutsourcedCrashGameIdlePresentation} from "./gameflow/OutsourcedCrashGameIdlePresentation";
import {OutsourcedCrashGameWinPresentation} from "./gameflow/OutsourcedCrashGameWinPresentation";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {GameInfoEventData} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/GameInfo";
import {Skinner} from "./Skinner";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";


export class Outsourced extends SlotGame {
    public static model: OutsourcedModel;
    public static assetLoader: AssetLoader;
    public static soundPlayer: OutsourcedSound;
    public static gameFlowController: GameFlowController;

    public static backgroundElements: OutsourcedBackgroundElements;
    public static foregroundElements: OutsourcedForegroundElements;
    public static reelView: OutsourcedReelView;
    public static winView: OutsourcedWinView;
    public static transitionScreen: OutsourcedTransitionScreenView;
    public static symbolFactory: OutsourcedSymbolFactory;

    public static maxWinHackjob:GameInfoEventData;
    public static isNJServer: boolean = false;
    private skinner:Skinner;

    constructor() {
        super();
        const validSkinIds:string[] = [
            "ug",
            "ozzo",
            "test",
            "bcgame",
            "sweep"
        ]
        this.skinner = new Skinner(validSkinIds);
    }

    private handleSweepInit() {
        //Making sure that skinID is set based  on "replaceWordFree" gcc.
        if (SlotGame.apiPlugin.gameClientConfiguration.isSet) {
            if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                this.skinner.skinId = "sweep";
            }
        } else {
            SlotGame.apiPlugin.events.on(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                    this.skinner.skinId = "sweep";
                }
            })
        }
    }


    public static isWinBelowStake(): boolean {
        return Outsourced.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (this.getAccumulatedRoundWin() <= this.getBetPrice());
    }

    public static wonNothing():boolean {
        return this.getAccumulatedRoundWin() == 0;
    }

    public static isWinAboveStake(): boolean {
        return this.getAccumulatedRoundWin() > this.getBetPrice();
    }

    public static getBetPrice(): number {
        const betLevel: string = Outsourced.apiPlugin.freeBets.hasFreeBets() ? Outsourced.apiPlugin.freeBets.getBet() : Outsourced.apiPlugin.betLevel.getLevel();
        let price: number = Outsourced.model.gameData?.playedBetValue || parseFloat(betLevel);
        if (Outsourced.model.data.wasFeatureBuy || Outsourced.model.data.boostedBet) {
            for (let index = 0; index < Outsourced.model.initData.featureBuyTimesBetValue.length; index++) {
                if (Outsourced.model.initData.featureBuyTimesBetValue[index].name === Outsourced.model.buyFeatureName) {
                    price *= Outsourced.model.initData.featureBuyTimesBetValue[index].price;
                    price = MathHelper.roundToDecimals(price, 2);
                    break;
                }
            }
        }
        return price
    }

    private static getAccumulatedRoundWin(): number {
        return Outsourced.model.data.accumulatedRoundWin;
    }

    getNoWinGameData(): any {
        return {
            "reels": [
                [
                    "M3",
                    "M5",
                    "L3",
                    "L2"
                ],
                [
                    "M1",
                    "L2",
                    "M4",
                    "L3"
                ],
                [
                    "M5",
                    "M3",
                    "M2",
                    "L1"
                ],
                [
                    "L3",
                    "M4",
                    "L1",
                    "L4"
                ]
            ],
            "evaluatedArea": [
                [
                    "M3",
                    "M5",
                    "L3",
                    "L2"
                ],
                [
                    "M1",
                    "L2",
                    "M4",
                    "L3"
                ],
                [
                    "M5",
                    "M3",
                    "M2",
                    "L1"
                ],
                [
                    "L3",
                    "M4",
                    "L1",
                    "L4"
                ]
            ],
            "betWayWins": [],
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "mode": "UPGRADE_BET",
            "nextMode": "NORMAL",
            "wasFeatureBuy": false,
            "boostedBet": false,
            "brokeTheBank": false,
            "freespinsTriggeredThisSpin": false,
            "freespinsPlayed": 0,
            "freespinsLeft": 0,
            "freespinsWinnings": 0,
            "serverTestInfo": {},
            "symbolSizes": [
                [
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1
                ]
            ],
            "splitSizes": [
                [
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1
                ]
            ],
            "xNudgeMultipliers": [
                0,
                0,
                0,
                0
            ],
            "upgradeBetCost": 5,
            "upgradeBetCount": 0,
            "winningSymbols": [],
            "wasCrashGameFeatureBuy": false,
            "freespinResponsesPlayed": 0,
            "scatterCount": 0,
            "newSymbols": [
                [
                    -1,
                    -1,
                    -1,
                    -1
                ],
                [
                    -1,
                    -1,
                    -1,
                    -1
                ],
                [
                    -1,
                    -1,
                    -1,
                    -1
                ],
                [
                    -1,
                    -1,
                    -1,
                    -1
                ]
            ],
            "previousKeptSymbols": [],
            "keptSymbols": [],
            "removedSymbols": [],
            "symbolSizesAtStart": [
                [
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1
                ]
            ],
            "hitPitySpin": false
        };
    }


    public getSymbolString(key: string, data: {
        3: number,
        4: number,
    }): string {
        return `
            <div class="symbol">
            <img src="{{gamePath}}screens/images/symbols/${key}.png">
            <div class="payout-group">
                <div class="payout">
                    <span class="number">4</span>
                    <span class="multiplier" data-multiplier="${data[4] * 0.05}">${data[4] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">3</span>
                    <span class="multiplier" data-multiplier="${data[3] * 0.05}">${data[3] * 0.05}</span>
                </div>
            </div>
            </div>
        `;
    }

    public getSymbolStringWild(data:{3:number, 4:number,}): string {
        return `
            <div class="symbol">
            <img src="{{gamePath}}screens/images/symbols/W.png">
            <div class="payout-group">
                <div class="payout">
                    <span class="number">4</span>
                    <span class="multiplier" data-multiplier="${data[4] * 0.05}">${data[4] * 0.05}</span>
                </div>
            </div>
            </div>
        `;
    }

    public getPaytable(): Promise<string> {
        const templateLoader = new TemplateLoader(SlotGame.apiPlugin.resources.getStaticRoot());
        templateLoader.add({
            name: "Paytable",
            url: "nolimit/screens/paytable.mustache"
        });


        let symbolDataValueData = OutsourcedStatics.defaultSymbolValues;
        if (Outsourced.model?.symbolValues) {
            symbolDataValueData = Outsourced.model.symbolValues;
            console.log("Using symbolValues from INIT data");
        } else {
            console.log("Using default symbolValues ");
        }


        return super.getPaytable().then((text:string)=>{





            const data : any = {
                godModeValue : this.getGodModeValue(),
                godModeDeluxe : this.getGodModeDeluxeValue(),
                gambleFiftyFiftyAllowed: Outsourced.apiPlugin.gameClientConfiguration.gambleFiftyFiftyAllowed,
                replaceWincapInfo: Outsourced.apiPlugin.gameClientConfiguration.replaceWincapInfo,
                showLowProbabilityGfx: Outsourced.apiPlugin.gameClientConfiguration.showLowProbabilityGfx,
                isExtraSpinFeature:Outsourced.model.initData.featureBuyTimesBetValue.some((feature:any) => feature.name==="EXTRA_SPIN"),
                skinPath:"screens/images/",
                sweepPath:"screens/images/"
            }
            if (this.skinner.skinId != undefined) {
                if (this.skinner.skinId === "sweep") {
                    data.sweepPath = `../resources/images/${this.skinner.skinId}/`;
                } else {
                    data.skinPath = `../resources/images/${this.skinner.skinId}/`;
                }
            }

            for (let key in symbolDataValueData) {
                text = text.replace(`{{${key}}}`, key == "W"
                                                  ? this.getSymbolStringWild(symbolDataValueData[key])
                                                  : this.getSymbolString(key, symbolDataValueData[key]));
            }

            //text = text.replace(/{{skinPath}}/g, data.skinPath);
            text = text.replace(new RegExp("#extraSpinAllowed", "g"), (!Outsourced.isNJServer && data.isExtraSpinFeature ? "" : "extraSpinsNotAllowed"));

            let translatedValue = Outsourced.apiPlugin.translations.render(text, data);
            if (Outsourced.isNJServer) {
                translatedValue = translatedValue.replace(new RegExp("5000", "g"), (Outsourced.maxWinHackjob.maxMultiplier!.toString()));
                translatedValue = translatedValue.replace("Max_Win.jpg", "wincap_NJ_US_50000x.jpg");
            }
            return translatedValue;
        });
    }

    public getGameRules(): Promise<string> {
        return super.getGameRules().then((value: string) => {
            const isExtraSpinFeature:boolean=Outsourced.model.initData.featureBuyTimesBetValue.some((feature:any) => feature.name==="EXTRA_SPIN");
            const gccData = Object.assign(Outsourced.apiPlugin.gameClientConfiguration);
            gccData.isNJServerJurNJPA = Outsourced.isNJServer && (Outsourced.apiPlugin.gameClientConfiguration.jurisdictionName == "US-NJ" || Outsourced.apiPlugin.gameClientConfiguration.jurisdictionName == "US-PA");
            let translatedData = Outsourced.apiPlugin.translations.render(value, gccData);
            translatedData = translatedData.replace(new RegExp("#actionSpinsAllowed", "g"), (Outsourced.apiPlugin.gameClientConfiguration.actionSpin ? "" : "actionSpinsNotAllowed"));
            translatedData = translatedData.replace(new RegExp("#extraSpinAllowed", "g"), (!Outsourced.isNJServer && isExtraSpinFeature ? "" : "extraSpinsNotAllowed"));
            translatedData = translatedData.replace(new RegExp("5000", "g"), (Outsourced.apiPlugin.gameClientConfiguration.replaceWincapInfo ? Outsourced.maxWinHackjob.maxMultiplier!.toString() : "5000"));
            return translatedData;
        });
    }

    public init(): Promise<NolimitPlugin> {
        return super.init().then((value: NolimitPlugin) => {
            (<any>globalThis).__PIXI_APP__ = NolimitApplication.pixiApp;
            Outsourced.symbolFactory = new OutsourcedSymbolFactory();
            Outsourced.model = new OutsourcedModel(SlotGame.apiPlugin, true);
            Outsourced.gameFlowController = new GameFlowController(SlotGame.apiPlugin, Outsourced.model);
            Outsourced.gameFlowController.flowStateLogger.level = LogLevel.DEV;
            Outsourced.isNJServer=!!(SlotKeypad.apiPlugIn.options && SlotKeypad.apiPlugIn.options.game && SlotKeypad.apiPlugIn.options.game.indexOf("NJ") > -1);

            const normalBet = new OutsourcedBetPresentation();
            const normalResult = new OutsourcedNormalResultPresentation();
            const normalWinPres = new OutsourcedWinPresentation();

            const freespinsIdle = new OutsourcedFreespinsIdlePresentation();
            const freespinsResult = new OutsourcedFreespinsResultPresentation();
            const freespinsWin = new OutsourcedFreespinsWinPresentation();

            const crashGameIdle = new OutsourcedCrashGameIdlePresentation();
            const crashGameWin = new OutsourcedCrashGameWinPresentation();

            Outsourced.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, new OursourcedIdleNormalPresentation()],
                [FlowState.BET, normalBet],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, normalWinPres]
            ]));
            Outsourced.gameFlowController.addGameModeFlowStatePresentationMap("NORMAL_RESPIN", new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, freespinsIdle],
                [FlowState.RESULT, freespinsResult],
                [FlowState.WIN, normalWinPres]
            ]));
            Outsourced.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, freespinsIdle],
                [FlowState.RESULT, freespinsResult],
                [FlowState.WIN, freespinsWin]
            ]));
            Outsourced.gameFlowController.addGameModeFlowStatePresentationMap("FREESPIN_RESPIN", new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, freespinsIdle],
                [FlowState.RESULT, freespinsResult],
                [FlowState.WIN, freespinsWin]
            ]));
            Outsourced.gameFlowController.addGameModeFlowStatePresentationMap("CRASH_GAME", new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, crashGameIdle],
                [FlowState.RESULT, {start: (flowStateController:FlowStateController) => flowStateController.finish()}],
                [FlowState.WIN, crashGameWin]
            ]));
            Outsourced.gameFlowController.addGameModeFlowStatePresentationMap("UPGRADE_BET", new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, {start: (flowStateController:FlowStateController) => {
                        if (Outsourced.model.shouldPlayExtraBet()) {
                            if (Outsourced.apiPlugin.isReplay)
                                Outsourced.transitionScreen.upgradeBet.replay(flowStateController);
                            else
                                Outsourced.transitionScreen.upgradeBet.enable(flowStateController);
                        } else {
                            Outsourced.apiPlugin.betHandler.zeroBet();
                            flowStateController.finish();
                        }
                    }}],
                [FlowState.RESULT, {start: (flowStateController:FlowStateController) => flowStateController.finish()}],
                [FlowState.WIN, {start: (flowStateController:FlowStateController) => flowStateController.finish()}]
            ]));
            Outsourced.gameFlowController.addGameModeFlowStatePresentationMap("CRASH_GAME_HANDSHAKE", new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, {start: (flowStateController:FlowStateController) => {
                        Outsourced.apiPlugin.betHandler.zeroBet();
                        flowStateController.finish()
                    }}],
                [FlowState.RESULT, {start: (flowStateController:FlowStateController) => flowStateController.finish()}],
                [FlowState.WIN, {start: (flowStateController:FlowStateController) => flowStateController.finish()}]
            ]));


            Outsourced.apiPlugin.events.once(APIEvent.GAME_INFO, (data: GameInfoEventData) => {
                Outsourced.maxWinHackjob = data;
            });
            this.handleSweepInit();
            return value;
        });
    }

    public getReady(): Promise<NolimitPlugin> {
        //Show intro and load game assets
        return super.getReady().then((value: NolimitPlugin) => {

            const fontLoader = new FontLoader(NolimitApplication.resourcePath);
            fontLoader.add(OpenSans.ITALIC_600);
            fontLoader.add(OpenSans.NORMAL_300);
            fontLoader.add(OpenSans.NORMAL_400);
            fontLoader.add(OpenSans.NORMAL_700);

            AssetsConfig.addToAssetsConfig(OutsourcedGameAssets.RESOURCES_GROUPS);
            Outsourced.assetLoader = new AssetLoader(Outsourced.apiPlugin, NolimitApplication.resourcePath + "/resources/");

            const promises = Promise.all([fontLoader.load(), Outsourced.assetLoader.load(ResourcesGroupName.MAIN)]);

            return promises.then((values: any) => {

                this.createViewsAndComponents();


                if (this.skinner.skinId != undefined) {
                    //Source folder for skin assets e.g "resources/images/skinName";
                    const assetPath:string = "resources/images/";
                    const replaceMap:Map<string, string> = new Map();



                    if(this.skinner.skinId === "sweep"){
                        replaceMap.set("BOOSTED_BET", "BOOSTED_BET.png");
                        replaceMap.set("betBoost", "betBoost.png");

                        replaceMap.set("pageImage_4", "pageImage_4.jpg");
                    }else{
                        //Bonus
                        replaceMap.set("FREESPIN_3_SCATTERS", "FREESPIN_3_SCATTERS.png");
                        replaceMap.set("FREESPIN_4_SCATTERS", "FREESPIN_4_SCATTERS.png");
                        replaceMap.set("LUCKY_DRAW", "LUCKY_DRAW.png");

                        //Intro
                        replaceMap.set(OutsourcedGameAssets.IMAGES_LOGO, "introLogo.png");

                        //Symbols
                        replaceMap.set("SC/SC", "SC.png");
                        replaceMap.set("SC/SC_2", "SC_2.png");
                        replaceMap.set("SC/SC_spin", "SC_spin.png");

                        //AS
                        replaceMap.set("AS_GAME_LOGO", "AS_GAME_LOGO.png");

                    }

                    this.skinner.loadSkin(assetPath, replaceMap).then(()=>{
                        return value;
                    });
                }

                return value;
            });
        });
    }

    public getReadyToStart(): Promise<NolimitPlugin> {
        //Game assets loaded, waiting for user to start game.
        return super.getReadyToStart().then((value: NolimitPlugin) => {

            RestoreUtils.startupGame();
            Outsourced.soundPlayer.switchMusic("INTRO");

            return value;
        });
    }

    public start(): Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.
        return super.start().then((value: NolimitPlugin) => {
            (<any>NolimitApplication.pixiApp.renderer.mask).enableScissor = true;

            Outsourced.gameFlowController.start();
            // hackjob for double or nothing restore music
            if (Outsourced.model.initData.nextMode == "GAMBLE_FIFTY_FIFTY") {
                Outsourced.soundPlayer.fadeOutMusic(1);
                Outsourced.soundPlayer.playLoopingSound("winCapLoop");
            } else {
                const music = Outsourced.model.data.nextMode == "UPGRADE_BET" ? "NORMAL" : Outsourced.model.data.mode;
                Outsourced.soundPlayer.switchMusic(music);
            }
            if (!Outsourced.model.isRestore && !Outsourced.apiPlugin.isReplay) {
                Outsourced.soundPlayer.playSoundBased("gameStartOneShot");
            }
            return value;
        });
    }

    private getGodModeValue(): string {
        for (let i: number = 0; i < Outsourced.model.initData.featureBuyTimesBetValue.length; i++) {
            if (Outsourced.model.initData.featureBuyTimesBetValue[i].name === "GOD_MODE") {
                return Outsourced.model.initData.featureBuyTimesBetValue[i].price.toString();
            }
        }

        return "";
    }

    private getGodModeDeluxeValue(): string {
        for (let i: number = 0; i < Outsourced.model.initData.featureBuyTimesBetValue.length; i++) {
            if (Outsourced.model.initData.featureBuyTimesBetValue[i].name === "GOD_MODE_DELUXE") {
                return Outsourced.model.initData.featureBuyTimesBetValue[i].price.toString();
            }
        }

        return "";
    }

    private createViewsAndComponents() {
        //Non views
        Outsourced.soundPlayer = new OutsourcedSound();

        //Static views
        Outsourced.backgroundElements = new OutsourcedBackgroundElements();
        Outsourced.reelView = new OutsourcedReelView();
        Outsourced.foregroundElements = new OutsourcedForegroundElements();
        Outsourced.winView = new OutsourcedWinView();
        Outsourced.transitionScreen = new OutsourcedTransitionScreenView();

        NolimitApplication.addLayerAt(Outsourced.transitionScreen.name, Outsourced.transitionScreen, 0);
        NolimitApplication.addLayerAt(Outsourced.winView.name, Outsourced.winView, 0);
        NolimitApplication.addLayerAt(Outsourced.foregroundElements.name, Outsourced.foregroundElements, 0);
        NolimitApplication.addLayerAt(Outsourced.reelView.name, Outsourced.reelView, 0);
        NolimitApplication.addLayerAt(Outsourced.backgroundElements.name, Outsourced.backgroundElements, 0);
    }

    public getNolimitBonusDisplayConfiguration():BonusFeatureDisplayConfigurationList {

        return {
            FREESPIN_3_SCATTERS:{
                displayName:"Snek Spins",
                displayOrder:0,
            },
            FREESPIN_4_SCATTERS:{
                displayName:"Snek Spins",
                displayOrder:1,
            },
            FREESPIN_5_SCATTERS:{
                displayName:"Super Snek Spins",
                displayOrder:2,
            },
            GOD_MODE:{
                displayName:"GOD MODE",
                displayOrder:3,
                replacePopUpContent:(content:BonusBuyPopUpContent) => {
                    const warningTextText = Outsourced.apiPlugin.gameClientConfiguration.replaceWincapInfo ? "Warning: 1 Spin. No Win or 5000 times the bet!" : "Warning: 1 Spin. No Win or Max Win!";
                    const warningText = new Label(Outsourced.apiPlugin.translations.translate(warningTextText),
                                                  content.textLabel.getStyleClone());
                    const scale = Math.min(560 / warningText.width, 1);
                    warningText.scale.set(0.7, 0.7);
                    warningText.anchor.set(0.5, 0.5);
                    warningText.position.set(0, 400);
                    content.addChild(warningText);

                    content.textLabel.scale.set(0.8, 0.8);
                    content.textLabel.position.y -= 30;

                    const godModeStillImage = content.featureImage;
                    const godModeSpine = new PIXI.spine.Spine(Outsourced.assetLoader.getSpineAsset(OutsourcedGameAssets.GOD_MODE_POPUP))
                    godModeSpine.state.setAnimation(0, "Loop", true);
                    godModeSpine.position.copyFrom(godModeStillImage);
                    godModeSpine.position.y += 100;

                    content.featureImage = <PIXI.Sprite>(<any>godModeSpine);
                    content.removeChild(godModeStillImage);
                    content.addChild(godModeSpine);


                    return content;
                }
            },
            LUCKY_DRAW:{
                displayName:"Lucky Draw",
                displayOrder:4,
            },
            CRASH_GAME:{
                displayName:"GOD MODE DELUXE",
                displayOrder:5,
                replacePopUpContent:(content:BonusBuyPopUpContent) => {
                    const warningTextText = Outsourced.apiPlugin.gameClientConfiguration.replaceWincapInfo ? "Bet your win of 5000 times the bet and win any amount from 5000x - 50,000x or lose it all!" : "Bet your Max Win and win up to 50,000x or lose it all!";
                    const warningText = new Label(Outsourced.apiPlugin.translations.translate(warningTextText),
                                                  content.textLabel.getStyleClone());
                    const scale = Math.min(560 / warningText.width, 1);
                    warningText.scale.set(0.7, 0.7);
                    warningText.anchor.set(0.5, 0.5);
                    warningText.position.set(0, 380);
                    content.addChild(warningText);

                    content.textLabel.scale.set(0.8, 0.8);
                    content.textLabel.position.y -= 30;

                    const godModeStillImage = content.featureImage;
                    const godModeSpine = new PIXI.spine.Spine(Outsourced.assetLoader.getSpineAsset(OutsourcedGameAssets.GOD_MODE_POPUP))
                    godModeSpine.state.setAnimation(0, "Loop_SG", true);
                    godModeSpine.position.copyFrom(godModeStillImage);
                    godModeSpine.position.y += 100;

                    content.featureImage = <PIXI.Sprite>(<any>godModeSpine);
                    content.removeChild(godModeStillImage);
                    content.addChild(godModeSpine);

                    return content;
                }
            },
            BOOSTED_BET:{
                displayName:"xBet",
                displayOrder:6,
            },
        }
    }
}